export default "__VITE_ASSET__DvkiLJDK__"